import * as React from 'react'
import { connect } from 'react-redux'
import type { PlaylistProps } from 'types/content-editor'
import type { Playlist } from 'types/playlist'
import { getPlaylistWithTracks } from '@disco/state-management/selectors/playlists'
import Checkbox from 'components/ui/checkbox'
import { emailColors } from '@disco/utils/colors'
import ColorInput from 'components/ui/color-input'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
import Input from 'components/ui/input'
import Label from 'components/ui/label'
import PlaylistSelect from 'pages/campaigns/campaign-details/playlist-select'
const blockSettingsColumns = [5, 7]
const buttonAlignment = [
  {
    value: 'left',
    label: 'left',
  },
  {
    value: 'center',
    label: 'center',
  },
  {
    value: 'right',
    label: 'right',
  },
]

const mapStateToProps = (state, { content: { playlist_id } }) => {
  return {
    playlist: getPlaylistWithTracks(state, {
      id: playlist_id,
    }),
  }
}

class PlaylistBlockSettings extends React.Component<
  {
    content: PlaylistProps
    playlist: Playlist
    onChange: (arg0: Record<string, any>) => any
  },
  null
> {
  render() {
    const { playlist, content, onChange } = this.props
    return (
      <div className="content-editor__playlist-block">
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption="Select playlist" />
          <PlaylistSelect
            value={
              playlist && playlist.playlist_id
                ? {
                    value: playlist.playlist_id,
                    label: playlist.name,
                  }
                : null
            }
            onChange={option => {
              const playlist_id = option ? option.value : null
              onChange({ ...content, playlist_id })
            }}
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption="Button position" />
          <CustomDropdown
            multi={false}
            options={buttonAlignment}
            value={content.buttonAlignment || ''}
            onChange={option =>
              onChange({ ...content, buttonAlignment: option.value })
            }
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption="Button text" />
          <Input
            value={content.buttonText}
            name="text"
            onChange={e => onChange({ ...content, buttonText: e.target.value })}
            className="Campaigns_LargeInput"
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption="Button text color" />
          <ColorInput
            colors={emailColors}
            name="color"
            portal
            value={content.buttonColor || ''}
            onChange={color => onChange({ ...content, buttonColor: color.hex })}
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption="Button color" />
          <ColorInput
            colors={emailColors}
            name="buttonBackgroundColor"
            portal
            value={content.buttonBackgroundColor || ''}
            onChange={color =>
              onChange({ ...content, buttonBackgroundColor: color.hex })
            }
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Checkbox
            label="Show header"
            checked={!content.disableHeader}
            onChange={() =>
              onChange({ ...content, disableHeader: !content.disableHeader })
            }
          />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, {})(PlaylistBlockSettings) as any
